import { Box, Button, Tooltip } from "@chakra-ui/react";
import { formatDate } from "@components/ui-kit";
import { Icon } from "@components/ui-kit/Icon";
import { Trans, t } from "@lingui/macro";
import type { ModelLockFragment } from "@src/__generated__/graphql";

type LockableColumnProps = {
  modelLock?: ModelLockFragment | null;
  canToggle?: boolean;
  onClick?: (locked: boolean) => void;
  isLoading?: boolean;
};

/**
 * Reusable lockable column component.
 */
export function LockableColumn({
  modelLock,
  canToggle = false,
  onClick,
  isLoading,
}: LockableColumnProps) {
  return modelLock?.is_locked ? (
    <Tooltip
      hasArrow
      label={
        <Box textAlign="center">
          <Trans>
            Locked by <strong>{modelLock.lockedByUser.full_name}</strong> on{" "}
            <strong>{formatDate(new Date(modelLock.locked_at))}</strong>
          </Trans>
          {canToggle && (
            <Box color="whiteAlpha.600" fontSize="xs">
              <Trans>Click to unlock</Trans>
            </Box>
          )}
        </Box>
      }
    >
      <Button
        isLoading={isLoading}
        onClick={() => (canToggle ? onClick?.(true) : null)}
        size="sm"
        variant="ghost"
      >
        <Icon name="lock-01" variant="line" color="red" />
      </Button>
    </Tooltip>
  ) : canToggle ? (
    <Tooltip label={t`Lock`}>
      <Button
        opacity={0}
        _groupHover={{
          opacity: 0.5,
          "&:hover": { opacity: 1 },
        }}
        isLoading={isLoading}
        onClick={() => onClick?.(false)}
        size="sm"
        variant="ghost"
      >
        <Icon name="lock-01" variant="line" />
      </Button>
    </Tooltip>
  ) : null;
}
